import { render, staticRenderFns } from "./OnTapIcon.vue?vue&type=template&id=3515428b&"
import script from "./OnTapIcon.vue?vue&type=script&lang=js&"
export * from "./OnTapIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports